import { LitElement, html, css } from 'lit-element';
import { clearAll, generateProfileImageByInitials } from '../../../lib/helpers';
import { Image } from '../Image/Image';
import'../../../components/ChatUIComponent/BlockChatList'
import { drawerDialogService } from '../Dialog-Drawer/dialog-drawer';
import { MOON, SUN } from '../../../constants/chat-assets';

export class ProfileTab extends LitElement {
  static get properties() {
    return {
      name: { type: String },
      isLoading: { type: Boolean },
      tempProfilePhotoUrl: { type: String },
      isEditingName: { type: Boolean },
      newName: { type: String },
      hasChanges: { type: Boolean },
      // Event handlers are now defined as methods in the class
      handleNameEdit: { type: Function },
      handleNameChange: { type: Function },
      handleNameKeyDown: { type: Function },
      handleNameSave: { type: Function },
      handleFileChange: { type: Function },
      handleManualUpdate: { type: Function },
      cancelChanges: { type: Function },
      closeDrawer: { type: Function },
      showBlockedUsers: { type: Boolean },
      defaultTheme: { type: String },
      toggleTheme: { type: Function },
    };
  }

  constructor() {
    super();
    this.name = '';
    this.isLoading = false;
    this.tempProfilePhotoUrl = null;
    this.isEditingName = false;
    this.newName = '';
    this.hasChanges = false;
    this.showBlockedUsers = false;
    // Initialize event handlers as empty functions
    this.handleNameEdit = () => {};
    this.handleNameChange = () => {};
    this.handleNameKeyDown = () => {};
    this.handleNameSave = () => {};
    this.handleFileChange = () => {};
    this.handleManualUpdate = () => {};
    this.cancelChanges = () => {};
    this.closeDrawer = () => {};
  }

  firstUpdated() {
    this.newName = this.name;
  }

  updated(changedProperties) {
    if (changedProperties.has('name') && this.name !== this.newName) {
      this.newName = this.name;
    }
  }

  // Custom method to trigger file input click
  triggerFileInput() {
    const fileInput = this.shadowRoot.querySelector('.file-input');
    if (fileInput) {
      fileInput.click();
    }
  }
  handleopenBlockList(){
    this.showBlockedUsers = true;
  }
  hideBlockedUsersView(){
    this.showBlockedUsers = false;
  }
  
    handleLogout(e) {
      e.stopPropagation();
      this.showLogoutPopup = !this.showLogoutPopup;
       drawerDialogService.openDialog('confirm-dialog', { 
            title: 'Logout', 
            description: `Are you sure you want to Logout ?`,
            handleConfirm:clearAll
          });
    }
  render() {
    if (this.showBlockedUsers) {
      return html`
        <block-chat-list
          .blockedUsers=${this.blockedUsers}
          .isLoading=${this.isLoadingBlockedUsers}
          .handleUnblock=${this.handleUnblockUser}
          .goBack=${() => this.hideBlockedUsersView()}
          .height="96%"
          >
        </block-chat-list>
      `;
    }
    return html`
      ${this.isLoading
        ? html`<div class="spinner-overlay">
            <spinner-loader
              height="30px"
              width="30px"
              spinTime="1s"
              spinnerPrimaryColor="var(--bg-primary-color)"
              spinnerSecondaryColor="var(--text-primary-color)"
              spinnerBorderWidth="2px"
            >
            </spinner-loader>
          </div>`
        : html`<div class="profile-container">
            <div class="header-profile">
              <div @click=${this.closeDrawer}>
                <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="var(--text-primary-color)">
                  <path d="m249-207-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z" />
                </svg>
              </div>
              <h1 class="profile-header">Profile</h1>
            </div>

            <div class="photo-container">
              <div class="profile-photo" @click=${this.triggerFileInput}>
                ${this.tempProfilePhotoUrl
                  ? html`<div class="photo-wrapper">
                      ${Image({
                        src: this.tempProfilePhotoUrl,
                        alt: 'profile image',
                        width: 'calc(75dvh - 300px)',
                        height: 'calc(75dvh - 300px)',
                        objectFit: 'cover',
                        borderRadius: '50%',
                        placeholderImage: generateProfileImageByInitials(this.name, 90, 90),
                      })}
                      <div class="hover-overlay">
                        <div class="d-flex flex-direction-column align-center">
                          <div class="camera-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                              <circle cx="12" cy="13" r="4"></circle>
                            </svg>
                          </div>
                          <span class="change-text">CHANGE PHOTO</span>
                        </div>
                      </div>
                    </div>`
                  : html`<div class="photo-placeholder">
                      <div class="camera-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                          <circle cx="12" cy="13" r="4"></circle>
                        </svg>
                      </div>
                      <span class="add-text">ADD PROFILE PHOTO</span>
                    </div>`}
              </div>
              <input type="file" accept="image/*" class="file-input" @change=${e => this.handleFileChange(e)} />
            </div>

            <div class="form-group">
              <label class="label">Your name</label>
              <div class="input-container">
                ${this.isEditingName
                  ? html`<input
                      type="text"
                      .value=${this.newName}
                      class="name-input"
                      @input=${this.handleNameChange}
                      @keydown=${this.handleNameKeyDown}
                      maxlength="20"
                      placeholder="Enter your Name"
                    />`
                  : html`<span class="input-text">${this.name}</span>`}
                <button class="edit-button" @click=${this.handleNameEdit}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                  </svg>
                </button>
              </div>
              <p class="helper-text">This name will be visible to your contacts. Only lowercase letters, numbers and underscore allowed (max 20 chars).</p>
            </div>

            ${this.hasChanges
              ? html`<div class="update-actions">
                  <button class="update-button" @click=${this.handleManualUpdate}>Update Profile</button>
                  <button class="cancel-button" @click=${this.cancelChanges}>Cancel</button>
                </div>`
              : null}

            <div class="bottom-actions">
              <button class="action-button" @click=${this.toggleTheme}>
                ${Image({
                  src: this.defaultTheme === 'dark' ? SUN : MOON,
                  alt: 'profile image',
                  width: '18px',
                  height: '18px',
                  objectFit: 'cover',
                  cursor: 'pointer',
                })}
                ${this.defaultTheme === 'dark' ? 'Light Theme' : 'Dark Theme'}
              </button>
              <button class="action-button" @click=${this.handleopenBlockList}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="8.5" cy="7" r="4"></circle>
                  <line x1="18" y1="8" x2="23" y2="13"></line>
                  <line x1="23" y1="8" x2="18" y2="13"></line>
                </svg>
                Block Users
              </button>
              <button class="action-button-logout" @click=${e => this.handleLogout(e)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                  <polyline points="16 17 21 12 16 7"></polyline>
                  <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                Logout
              </button>
            </div>
          </div>`}
    `;
  }

  static get styles() {
    return css`
      :host {
        display: flex;
        flex-direction: column;
        height: 100%;
        font-size: 16px; /* Base font size */
      }
      
      .profile-container {
        padding: 5px;
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
        background-color:var(--bg-primary-color);
      }

      .profile-header {
        font-size: 1.5rem; /* 24px at base size */
        font-weight: 500;
        margin-left: 10px;
        color:var(--text-primary-color);
      }

      .photo-container {
        display: flex;
        justify-content: center;
        margin-bottom: 40px;
        position: relative;
      }

      .profile-photo {
        width: calc(75dvh - 300px);
        height: calc(75dvh - 300px);
        border-radius: 50%;
        background-color: var(--bg-incoming-message);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
        cursor: pointer;
      }

      .photo-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
      }

      .hover-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s ease;
        border-radius: 50%;
      }

      .photo-wrapper:hover .hover-overlay {
        opacity: 1;
      }

      .photo-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      .camera-icon {
        background-color: var(--bg-incoming-message);
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 5px;
      }

      .camera-icon svg {
        color: var(--text-incoming-message);
        width: 22px;
        height: 22px;
      }

      .add-text,
      .change-text {
        font-size: 0.75rem; /* 12px at base size */
        text-align: center;
        padding: 0 15px;
        color: var(--text-incoming-message);
      }

      .form-group {
        margin-bottom: 30px;
      }

      .label {
        font-size: 1em;
        color: var(--text-secondary-color);
        margin-bottom: 10px;
        display: block;
      }

      .input-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid var(--bg-secondary-color);
        padding-bottom: 10px;
      }

      .input-text {
        font-size: 1rem; /* 16px at base size */
        color: var(--text-primary-color);
      }

      .edit-button {
        background: none;
        border: none;
        cursor: pointer;
        color: var(--text-secondary-color);
        padding: 5px;
      }

      .helper-text {
        font-size: 0.75rem; /* 12px at base size */
        color: var(--text-secondary-color);
        margin-top: 8px;
      }

      .file-input {
        display: none;
      }

      .name-input {
        background: var(--bg-secondary-color);
        border: none;
        color: var(--text-outgoing-message);
        font-size: 1rem; /* 16px at base size */
        width: 100%;
        padding: 0;
        outline: none;
      }

      .upload-progress {
        width: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .d-flex {
        display: flex;
      }
      .flex-direction-column {
        flex-direction: column;
      }
      .align-center {
        align-items: center;
      }
      .spinner-overlay {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
         background-color:var(--bg-primary-color);
      }
      .update-actions {
        display: flex;
        gap: 10px;
        margin-top: 20px;
      }

      .update-button,
      .cancel-button {
        padding: 8px 16px;
        border-radius: 4px;
        font-weight: 500;
        cursor: pointer;
        border: none;
        transition: background-color 0.2s, transform 0.1s;
        font-size: 0.875rem; /* 14px at base size */
      }

      .update-button {
        background-color: var(--base-color);
        color: var(--text-incoming-message);
      }

      .update-button:hover {
        transform: translateY(-1px);
      }

      .update-button:active {
        transform: translateY(0);
      }

      .cancel-button {
        background-color: var(--bg-grey-color);
        color: var();
      }

      .cancel-button:hover {
        background-color: var(--text-primary-color);
        transform: translateY(-1px);
      }

      .cancel-button:active {
        transform: translateY(0);
      }

      /* Disabled state for buttons */
      .update-button:disabled,
      .cancel-button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
      }
      .header-profile {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-top: 10px;
        margin-bottom: 30px;
        cursor: pointer;
      }

      .bottom-actions{
        margin-top: auto;
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 20px 0;
      }

      .action-button,
      .action-button-logout {
        display: flex;
        align-items: center;
        gap:10px;
        background: none;
        border: none;
        cursor: pointer;
        color: var(--text-outgoing-message);
        font-size: 1rem; /* 16px at base size */
        padding: 8px 0;
        text-align: left;
        transition: color 0.2s;
      }

      .action-button-logout:hover {
        color: var( --text-danger-color);
      }

      .action-button svg ,
      .action-button-logout svg{
        width: 18px;
        height: 18px;
      }

      /* Responsive font sizes and spacing for different screen sizes */
      @media (max-width: 768px) {
        :host {
          font-size: 14px; /* Smaller base font on tablets */
        }
        
        .camera-icon {
          width: 40px;
          height: 40px;
        }
        
        .camera-icon svg {
          width: 18px;
          height: 18px;
        }
      }

      @media (max-width: 480px) {
        :host {
          font-size: 12px; /* Even smaller base font on mobile */
        }
        
        .profile-header {
          font-size: 1.4rem; /* Slightly smaller header on mobile */
        }
        
        .update-actions {
          flex-direction: column;
        }

        .update-button,
        .cancel-button {
          width: 100%;
        }
        
        .camera-icon {
          width: 36px;
          height: 36px;
        }
        
        .camera-icon svg {
          width: 16px;
          height: 16px;
        }
        
        .form-group {
          margin-bottom: 20px; /* Less spacing on mobile */
        }
      }
    `;
  }
}

customElements.define('profile-tab', ProfileTab);